import { FaInstagram, FaFacebook, FaLinkedin, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import logo from '../assets/logo.png';
import './Footer.css';

const quickLinks = ['Home', 'Services', 'Packages', 'Contact'];
const serviceLinks = [
  ['Business Registration', 'GST Registration'],
  ['Income Tax Filing', 'Website Development'],
  ['Digital Marketing', 'Financial Modelling'],
  ['MSME Registration', 'Business Consulting'],
];

export default function Footer() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="footer">
      <div className="container footer__grid">
        {/* Brand */}
        <div className="footer__brand">
          <img src={logo} alt="RRP & Associates" className="footer__logo" />
          <p className="footer__tagline">From Registration to Revenue — We Handle Everything</p>
          <div className="footer__socials">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
          </div>
        </div>

        {/* Quick links */}
        <div className="footer__col">
          <h4 className="footer__col-title">Quick Links</h4>
          <ul>
            {quickLinks.map((l) => (
              <li key={l}>
                <a
                  href={`#${l.toLowerCase()}`}
                  onClick={(e) => { e.preventDefault(); scrollTo(`#${l.toLowerCase()}`); }}
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div className="footer__col footer__col--services">
          <h4 className="footer__col-title">Our Services</h4>
          <div className="footer__services-grid">
            {serviceLinks.map(([a, b]) => (
              <div key={a} className="footer__services-row">
                <a href="#services" onClick={(e) => { e.preventDefault(); scrollTo('#services'); }}>{a}</a>
                <a href="#services" onClick={(e) => { e.preventDefault(); scrollTo('#services'); }}>{b}</a>
              </div>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div className="footer__col">
          <h4 className="footer__col-title">Contact Us</h4>
          <div className="footer__contact-items">
            <a href="tel:+919422611832" className="footer__contact-item">
              <FaPhone /> +91-9422611832
            </a>
            <a href="mailto:ravindrarpuri2022@gmail.com" className="footer__contact-item">
              <FaEnvelope /> ravindrarpuri2022@gmail.com
            </a>
            <span className="footer__contact-item">
              <FaMapMarkerAlt /> Pune, Maharashtra, India
            </span>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>© 2024 RRP & Associates. All rights reserved.</p>
          <p className="footer__bottom-right">
            Designed with ❤️ for Indian entrepreneurs
          </p>
        </div>
      </div>
    </footer>
  );
}
